<template>
    <div class="product-gallery">
        <div class="columns is-multiline is-mobile">
            <product class="column is-one-fifth-fullhd is-one-quarter-desktop is-one-third-tablet is-half-mobile"
                     v-for="product in products"
                     :product="product"
                     :key="product.id"
                     v-on:product-selected="onProductSelected">
            </product>
        </div>
    </div>
</template>

<script>
    import Product from '../../components/product/Product.vue';

    export default {
        name: 'product-listing',
        props: ['products'],
        components: {
            Product
        },

        methods: {
            onProductSelected(id) {
                this.$emit('product-selected', id);
            }
        }
    }
</script>

<style lang="scss" scoped>
    .product-gallery {
        .column {
            margin-bottom: 40px;
        }
    }
</style>